<app-title-bar titleText="i18n.base.registration.header"></app-title-bar>

<form id="registerForm" [formGroup]="registerForm" autocomplete="off">
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
      <ejs-stepper stepType="Default" [activeStep]="stepIndex" [readOnly]="true">
        <e-steps>
          <e-step></e-step>
          <e-step></e-step>
          <e-step></e-step>
        </e-steps>
      </ejs-stepper>
    </div>
  </div>
  <div class="row mt-4">
    <div [hidden]="stepIndex !== 0">
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <div class="form-row row">
          <div class="form-group col-12">
            <label for="firstname" class="control-label required">
              {{'i18n.base.user-add-modal.firstname' | translate }}
            </label>
            <input id="firstname" name="firstname" type="text" autocomplete="off" class="form-control" formControlName="firstname" />
            <app-error-messages [control]="registerForm.controls.firstname"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-12">
            <label for="lastname" class="control-label required">
              {{'i18n.base.user-add-modal.lastname' | translate }}
            </label>
            <input id="lastname" name="lastname" type="text" autocomplete="off" class="form-control" formControlName="lastname" />
            <app-error-messages [control]="registerForm.controls.lastname"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-12">
            <label for="email" class="control-label required">
              {{'i18n.base.user-add-modal.email' | translate }}
            </label>
            <input id="email" name="email" type="email" autocomplete="off" class="form-control" formControlName="email" />
            <app-error-messages [control]="registerForm.controls.email"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-12">
            <label for="password" class="control-label required">
              {{'i18n.base.registration.password' | translate }}
            </label>
            <app-password-input inputId="password"
                                name="password"
                                autocomplete="new-password"
                                formControlName="password">
            </app-password-input>
            <app-error-messages [control]="registerForm.controls.password"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-12">
            <label for="confirmPassword" class="control-label required">
              {{'i18n.base.registration.passwordConfirm' | translate }}
            </label>
            <app-password-input inputId="confirmPassword"
                                name="confirmPassword"
                                autocomplete="new-password"
                                formControlName="confirmPassword">
            </app-password-input>
            <app-error-messages [control]="registerForm.controls.confirmPassword"></app-error-messages>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="text-end">
              <button type="button" class="btn btn-secondary" (click)="goToNextStep()" [disabled]="!isFirstStepValid()">
                {{ "i18n.base.registration.next" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="stepIndex !== 1">
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label class="control-label">
              {{'i18n.base.user-add-modal.address' | translate }}
            </label>
            <app-address-autofill [addressForm]="registerForm"></app-address-autofill>
            <app-error-messages [control]="registerForm.controls.fullAddress"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label for="phoneNumber" class="control-label">
              {{'i18n.base.user-add-modal.phoneNumber' | translate }}
            </label>
            <input id="phoneNumber" name="phoneNumber" type="text" autocomplete="off" class="form-control" formControlName="phoneNumber" />
            <app-error-messages [control]="registerForm.controls.phoneNumber"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label class="control-label required">
              {{'i18n.base.user-add-modal.language' | translate }}
            </label>
            <ejs-dropdownlist [dataSource]="languageDropDowItems"
                              [fields]="languageDropdownSettings"
                              [showClearButton]="true"
                              id="language"
                              formControlName="language">
            </ejs-dropdownlist>
            <app-error-messages [control]="registerForm.controls.language"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label class="form-check-label d-flex align-items-center w-100 justify-content-between" style="gap: 1rem;">
              <span class="flex-grow-1" style="word-break: break-word;">
                <span [innerHTML]="'i18n.base.registration.terms-conditions' | translate"></span>
              </span>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="text-end">
              <a type="button" class="btn btn-secondary" (click)="goToPreviousStep()">
                {{ "i18n.base.forgot-password.back-button" | translate }}
              </a>
              <button type="submit" class="btn btn-primary ms-2" (click)="submitForm()" [disabled]="!registerForm.valid">
                {{ "i18n.base.registration.register" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="stepIndex !== 2">
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <div>
          <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.forgot-password.success-info" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- @if (registerForm){
  <div class="alert alert-secondary mt-3">
    <strong>Form Values:</strong>
    <pre>{{ registerForm.getRawValue() | json }}</pre>
  </div>
} -->
